/*
This file contains a simple react component that handles the e-conomic redirect URL.

We will fetch the token from the URL and create a new e-conomic integration for the user.
If no integration exists, that is.

Once the integration is created, we will redirect the user back to the main page.
The first sync will be handled automatically by the SyncStatus component.
*/
import { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Grid,
  InputLabel,
  Typography,
} from "@mui/material";
import axios from "../../utils/axios";
import {
  getStoredEconomicToken,
  clearEconomicToken,
  setPostIntegrationFlags,
} from "./economicUtils";

const EconomicConnect = () => {
  const [creatingIntegration, setCreatingIntegration] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const economicToken = getStoredEconomicToken();

    const createIntegration = async () => {
      if (economicToken) {
        try {
          setCreatingIntegration(true);
          await axios.post(
            "/v1/integrations/create-integration/",
            JSON.stringify({ identifier: "economic", secret: economicToken }),
            { withCredentials: true },
          );
          setCreatingIntegration(false);
          clearEconomicToken();
          setPostIntegrationFlags();
          window.location.href = "/";
        } catch (error) {
          console.error("Error creating integration:", error);
          setCreatingIntegration(false);
          setError("Failed to create integration. Please try again.");
        }
      } else {
        setError("No economic token found. Please try connecting again.");
      }
    };

    createIntegration();
  }, []);

  return (
    <Box sx={{ bgcolor: "secondary.main" }}>
      <Grid container direction="row" spacing={3} alignContent="center">
        <Grid size={{ xs: 12, lg: 12 }}>
          <InputLabel sx={{ marginBottom: "3%", marginTop: "4%" }}>
            Connecting to e-conomic
          </InputLabel>
          <CircularProgress></CircularProgress>
          <Typography sx={{ marginTop: "1.5%", marginBottom: "1.5%" }}>
            {error ? (
              <span style={{ color: "red" }}>{error}</span>
            ) : creatingIntegration ? (
              "Creating integration..."
            ) : (
              "Integration created successfully, redirecting..."
            )}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EconomicConnect;
